/**
 * HOC that adds the prop `disabled` if the decorated form node editing is locked.
 */

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { getFormNodeEditingLocked } from 'common/entities/formNode/selectors';

const mapStateToProps = (state, props) => {
    const editingLocked = props.formNodeId ? getFormNodeEditingLocked(state, props.formNodeId) : false;
    return {
        disabled: editingLocked,
    };
};

const disableWhenLocked = connect(mapStateToProps);

disableWhenLocked.propTypes = {
    formNodeId: PropTypes.string.isRequired,
};

export default disableWhenLocked;
